module.exports = __webpack_public_path__ + "img/btn.e35118fd.png";